import React, { useState } from "react";
import PropTypes from "prop-types";
import { Shirt, Type, Sparkles, Upload, Download, Save, Share2 } from "lucide-react";

import { Box, Typography, Paper } from "@mui/material";

const menuItems = [
  { icon: Shirt, label: "Sản phẩm", action: "product" },
  { icon: Type, label: "Văn bản", action: "text" },
  { icon: Sparkles, label: "Sticker", action: "sticker" },
  { icon: Upload, label: "Tải lên", action: "upload" },
  { icon: Download, label: "Tải xuống", action: "download" },
  { icon: Save, label: "Lưu ảnh", action: "save" },
  { icon: Share2, label: "Chia sẻ", action: "share" },
];

function SidebarMenu({ onAction, onDownload, onShare, onSave, direction = "column" }) {
  const [active, setActive] = useState("product");

  const handleClick = (action) => {
    setActive(action);
    if (action === "share") {
      onShare?.();
    } else if (action === "download") {
      onDownload?.();
    } else if (action === "save") {
      onSave?.();
    } else {
      onAction(action);
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%", // ✅ full theo cha
        minWidth: "100%",
        height: "100%",
        p: 0,
        boxSizing: "border-box", // ✅ tránh cộng thêm padding
        borderRadius: direction === "row" ? 0 : "0 16px 16px 0",
        display: "flex",
        flexDirection: direction,
        alignItems: "center",
        justifyContent: {
          xs: "center",
          md: direction === "column" ? "flex-start" : "flex-start",
        },
        pt: 1,
        bgcolor: "white",
      }}
    >
      {menuItems.map((item, idx) => {
        const Icon = item.icon;
        const isActive = active === item.action;

        return (
          <Box
            key={idx}
            role="button"
            tabIndex={0}
            onClick={() => handleClick(item.action)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleClick(item.action);
            }}
            sx={{
              width: { xs: 48, sm: 56, md: 64 },
              height: { xs: 48, sm: 56, md: 64 },
              mx: direction === "row" ? 0.5 : 0,
              my: direction === "column" ? 0.5 : 0,
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.2s",
              bgcolor: isActive ? "#0094FF" : "white",
              "&:hover": {
                bgcolor: isActive ? "#0094FF" : "#00518C",
                "& svg": {
                  color: "#fff",
                },
                "& .menu-label": {
                  color: "#fff",
                },
              },
              "& svg": {
                color: isActive ? "#fff" : "#1F2225",
                fontSize: { xs: 18, sm: 20, md: 24 },
              },
            }}
          >
            <Box
              sx={{
                width: { xs: 12, sm: 18, md: 24 },
                height: { xs: 12, sm: 18, md: 24 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon size="100%" />
            </Box>

            <Typography
              className="menu-label"
              sx={{
                fontSize: { xs: "10px", sm: "11px" },
                mt: 0.5,
                textAlign: "center",
                color: isActive ? "#fff" : "#1F2225",
              }}
            >
              {item.label}
            </Typography>
          </Box>
        );
      })}
    </Paper>
  );
}

SidebarMenu.propTypes = {
  onAction: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(["row", "column"]),
};

SidebarMenu.defaultProps = {
  direction: "column",
};

export default SidebarMenu;
